const SET_PROJECT_NEW_NOTE_CONTENTS = "SET_PROJECT_NEW_NOTE_CONTENTS";

export default { SET_PROJECT_NEW_NOTE_CONTENTS };
